import { useState } from 'react'
import { Board } from '../types'
import { mockBoards } from '../data/mockBoards'

export function useBoards() {
  const [boards, setBoards] = useState<Board[]>(mockBoards)

  const createBoard = (name: string, isPrivate: boolean = false) => {
    const newBoard: Board = {
      id: `b${Date.now()}`,
      name,
      pinCount: 0,
      isPrivate,
    }
    setBoards([newBoard, ...boards])
  }

  return {
    boards,
    createBoard,
  }
}
